import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksServices: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICES,
	},
	getDoneWorksServicePreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE_PREVIEW,
	},
	getDoneWorksServicePopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE_POPUP,
	},
	createDoneWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].CREATE_DONE_WORKS_SERVICE,
	},
	getDoneWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE,
	},
	patchDoneWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].PATCH_DONE_WORKS_SERVICE,
	},
	putDoneWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].PUT_DONE_WORKS_SERVICE,
	},
	deleteDoneWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].DELETE_DONE_WORKS_SERVICE,
	},
}